// Dynamic Series — curated detail gallery.
// Strict rule: every image must be visually distinct. No duplicate sources.
// Captions speak about the design language, not features.

export const DYNAMIC_SERIES_GALLERY = [
  {
    src: "https://customer-assets.emergentagent.com/job_intelligent-living-8/artifacts/j9vp14qh_457768.jpg",
    caption: "Crafted to disappear",
    note: "Sculpted glass meets precision-milled aluminium.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_intelligent-living-8/artifacts/8st34l65_455060.jpg",
    caption: "Made in many moods",
    note: "A finish for every palette of interior.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_intelligent-living-8/artifacts/l90gxjmg_455044.jpg",
    caption: "Scenes, your way",
    note: "Easy-to-customise scenes through the GenieX app.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_intelligent-living-8/artifacts/o3zkzexk_455058.jpg",
    caption: "Ambient intelligence",
    note: "Live time, weather and scenes — at a glance.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_intelligent-living-8/artifacts/v2eq7cyk_455040.jpg",
    caption: "Curated surfaces",
    note: "Champagne. Graphite. Brushed steel. Brass.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_intelligent-living-8/artifacts/mv51sc70_457836.jpg",
    caption: "Living display",
    note: "Quietly visible. Dark when you don't need it.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_intelligent-living-8/artifacts/tn227dk5_457765.jpg",
    caption: "Architectural detail",
    note: "Designed to belong to the wall, not on it.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_intelligent-living-8/artifacts/j541h9uy_457767.jpg",
    caption: "Premium materials",
    note: "Glass. Leather. Milled aluminium. Brass.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_intelligent-living-8/artifacts/y8ebmjwt_fe190fe7-6971-431a-8dc1-f021b9f73f5b.jpeg",
    caption: "Whisper-soft touch",
    note: "Capacitive response with haptic feedback.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_intelligent-living-8/artifacts/3m4kucxa_847ba0e4-027c-489c-86d7-d1f204e6d182.jpeg",
    caption: "Backlit, always",
    note: "Auto-dimming brightness across the day.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_intelligent-living-8/artifacts/km0qdju3_20b0d489-ecb2-4876-8870-224f37163049.jpeg",
    caption: "A family of modules",
    note: "From 4M to 12M — one design language.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_intelligent-living-8/artifacts/7qznj8ps_01776beb-c6f6-44bf-9c71-c19e59865e2a.jpeg",
    caption: "Engineered for India",
    note: "Tuned for Indian voltage and modular boxes.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_intelligent-living-8/artifacts/bv52rl0r_a07d7aba-0683-41a0-b683-4a512fe794c1.jpeg",
    caption: "Hand-finished",
    note: "Each panel hand-checked before it ships.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_02c2031d-1849-4c22-82f8-c45a977f713b/artifacts/p0ua8grm_457739.webp",
    caption: "Family of form",
    note: "Cohesive across every panel, every room.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_02c2031d-1849-4c22-82f8-c45a977f713b/artifacts/nh17fdoi_460992.png",
    caption: "Tasteful detail",
    note: "Every edge, every chamfer, intentional.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_02c2031d-1849-4c22-82f8-c45a977f713b/artifacts/izm2vr21_461007.png",
    caption: "Made to last",
    note: "Five-year warranty. In writing.",
  },
];
